// @ts-nocheck
import { selector } from "recoil";
import { documentCategories } from "./atom";

export const setDocumentCategories = selector<any>({
  key: "setDocumentCategories",
  get: () => null,
  set: ({ set }, documentCategoriesData) => {
    set(documentCategories, documentCategoriesData);
  },
});

export const getDocumentCategories = selector<any>({
  key: "getDocumentCategories",
  get: ({ get }) => {
    return get(documentCategories);
  },
});